import camelCase from 'lodash/camelCase'

export function camelCaseKeys(obj: unknown): unknown {
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  if (Array.isArray(obj)) {
    return (obj as unknown[]).map(item => camelCaseKeys(item))
  }

  const input = obj as Record<string, unknown>
  return Object.keys(input).reduce(
    (result, key) => ({
      ...result,
      [camelCase(key)]: camelCaseKeys(input[key]),
    }),
    {} as Record<string, unknown>
  )
}
